import { OfficePaperExtraDto } from './../models/server-models/entities/office-paper-extra-dto';
import { inject, Injectable } from '@angular/core';
import { OfficePrintVariationDto } from '../models/server-models/entities/office-print-variation-dto';
import { PrintVariationType } from '../models/server-models/enums/print-variation-type';
import { HttpClient } from '@angular/common/http';
import { ExpandedPrintVariation } from '../models/client-models/entities/expanded-print-variation';
import { PrintOfficeDto } from '../models/server-models/entities/print-office-dto';
import _ from 'lodash';
import { ExpandedPaperSize } from '../models/client-models/entities/expanded-paper-size';
import { ExpandedPaperType } from '../models/client-models/entities/expanded-paper-type';
import { ExpandedPaperExtra } from '../models/client-models/entities/expanded-paper-extra';
import { PaperExtraType } from '../models/server-models/enums/paper-extra-type';

@Injectable({ providedIn: 'root' })
export class PrintVariationService {
  httpClient = inject(HttpClient);

  constructor() {}

  getPrintVariations(offices: PrintOfficeDto[] | null): ExpandedPrintVariation[] {
    if (offices == null) return [];

    return _(offices)
      .flatMap((o) => o.printVariations)
      .groupBy((g) => g.printVariationId)
      .map((grouppedVariations) => {
        let pv = grouppedVariations[0];

        return <ExpandedPrintVariation>{
          id: pv.printVariationId,
          name: pv.name,
          description: pv.description,
          type: pv.type,
          icon: this.getIconByType(pv),
          priority: pv.priority,
          paperSizes: _(grouppedVariations)
            .flatMap((x) => x.paperSizes)
            .groupBy((v) => v.paperSizeId)
            .map((grouppedSizes) => {
              let ps = grouppedSizes[0];

              return <ExpandedPaperSize>{
                id: ps.paperSizeId,
                name: ps.name,
                width: ps.width,
                height: ps.height,
                type: ps.type,
                priority: ps.priority,
                paperTypes: _(grouppedSizes)
                  .flatMap((x) => x.paperTypes)
                  .groupBy((x) => x.paperTypeId)
                  .map((grouppedTypes) => {
                    let pt = grouppedTypes[0];

                    return <ExpandedPaperType>{
                      id: pt.paperTypeId,
                      name: pt.name,
                      description: pt.description,
                      priority: pt.priority,
                      paperExtras: _(grouppedTypes)
                        .flatMap((x) => x.paperExtras)
                        .groupBy((x) => x.paperExtraId)
                        .map((grouppedExtras) => {
                          let pe = grouppedExtras[0];

                          return <ExpandedPaperExtra>{
                            id: pe.paperExtraId,
                            name: pe.name,
                            priority: pe.priority,
                            applyScope: pe.applyScope,
                            type: pe.type,
                            icon: this.getPaperExtraIconByType(pe),
                          };
                        })
                        .orderBy((pv) => pv.priority)
                        .value(),
                    };
                  })
                  .orderBy((pv) => pv.priority)
                  .value(),
              };
            })
            .orderBy((pv) => pv.priority)
            .value(),
        };
      })
      .orderBy((pv) => pv.priority)
      .value();
  }

  getIconByType(variation: OfficePrintVariationDto) {
    switch (variation.type) {
      case PrintVariationType.Image:
        return 'images-outline';
      case PrintVariationType.Book:
        return 'book-outline';
      case PrintVariationType.BusinessCard:
        return 'person-circle-outline';
      case PrintVariationType.Certificate:
        return 'ribbon-outline';
      case PrintVariationType.GeneralPrint:
        return 'print-outline';
    }
  }

  getPaperExtraIconByType(extraDto: OfficePaperExtraDto) {
    switch (extraDto.type) {
      case PaperExtraType.Colored:
        return 'color-palette-outline';
      case PaperExtraType.Lamination:
        return 'browsers-outline';
      case PaperExtraType.Binding:
        return 'layers-outline';
      case PaperExtraType.Frame:
        return 'image-outline';
    }
  }
}
